export const ANALYZE_TRACKING_EVENTS = Object.freeze({
    MODULE_OPENED: "e_analyze_module_opened",
    TAB_VIEWED: "e_analyze_tab_viewed",
    TAB_LEFT: "t_analyze_tab_left",
    TAB_CHANGED: "e_analyze_tab_changed",

    METRIC_OPENED: "e_analyze_metric_opened",
    METRIC_CARD_TOGGLED: "e_analyze_metric_card_toggled",
    METRIC_COMPARE_MODE_TOGGLED: "e_analyze_metric_compare_mode_toggled",
    METRIC_COMPARE_OPENED: "e_analyze_metric_compare_opened",
    METRIC_COMPARE_SCOPE_APPLIED: "e_analyze_metric_compare_scope_applied",
    METRIC_BREAKDOWN_ROW_EXPANDED: "e_analyze_metric_breakdown_row_expanded",

    FILTER_APPLIED: "e_analyze_filter_applied",
    DATE_PRESET_CHANGED: "e_analyze_date_preset_changed",
    COMPARISON_MODE_CHANGED: "e_analyze_comparison_mode_changed",
    DATE_RANGE_CHANGED: "e_analyze_date_range_changed",

    WARNING_OPENED: "e_analyze_warning_opened",
    WARNING_DETAIL_SELECTED: "e_analyze_warning_detail_selected",

    MEASURE_CREATED: "e_analyze_measure_created",
    BASELINE_CREATED: "e_analyze_baseline_created",

    HEATING_OVERVIEW_ROW_EXPANDED: "e_analyze_heating_overview_row_expanded",

    EXPORT_REQUESTED: "e_analyze_export_requested",
    EXPORT_DOWNLOADED: "e_analyze_export_downloaded",

    PORTFOLIO_EXPORT_REQUESTED: "e_analyze_portfolio_export_requested",
    PORTFOLIO_DETAIL_OPENED: "e_analyze_portfolio_detail_opened",

    UPSELL_HINT_CLICKED: "e_analyze_upsell_hint_clicked",
    UPSELL_LEFT: "t_analyze_upsell_teaser_left",
    UPSELL_ACTION_CLICKED: "e_analyze_upsell_cta_clicked",
} as const);

export const ANALYZE_ENTRY_PATHS = Object.freeze({
    MENU: "menu",
    OTHER: "other",
} as const);

export const ANALYZE_LICENSE_TIERS = Object.freeze({
    NONE: "none",
    BASIC: "basic",
    PREMIUM: "premium",
    ENTERPRISE: "enterprise",
} as const);

export const ANALYZE_NAVIGATION_SOURCES = Object.freeze({
    TAB_BAR: "tab_bar",
    OVERVIEW_SIDEBAR: "overview_sidebar",
    OVERVIEW_METRICS_LINK: "overview_metrics_link",
    PORTFOLIO_DETAIL_MODAL: "portfolio_detail_modal",
    METRIC_ROW: "metric_row",
    OPERATING_BEHAVIOUR_SECTION: "operating_behaviour_section",
    METRIC_DETAIL_MODAL: "metric_detail_modal",
} as const);

export const ANALYZE_FILTER_TYPES = Object.freeze({
    SPACE_PURPOSE: "space_purpose",
    OCCUPANCY: "occupancy",
    EVENT_TYPE: "event_type",
    GROUP_BY: "group_by",
    SORT_BY: "sort_by",
    SEARCH_TEXT: "search_text",
    DEVICE: "device",
    INTERVAL: "interval",
    TREND_LEVEL: "trend_level",
    VIEW: "view",
    SCOPE_LEVEL: "scope_level",
    EXPORT_SECTION: "export_section",
} as const);

export const ANALYZE_FILTER_CONTEXTS = Object.freeze({
    OVERVIEW: "overview",
    HEATING_TABLE: "heating_table",
    CONSUMPTION: "consumption",
    METRICS: "metrics",
    METRIC_DETAIL: "metric_detail",
    METRIC_COMPARE: "metric_compare",
    OPTIMIZATION: "optimization",
    MEASURES: "measures",
    MEASURE_CHANGES: "measure_changes",
    PORTFOLIO: "portfolio",
    EXPORT: "export",
} as const);

export const ANALYZE_UPSELL_PLACEMENTS = Object.freeze({
    NO_LICENSE_PAGE: "no_license_page",
    LOCKED_TAB: "locked_tab",
    OVERVIEW_OCCUPANCY_FILTER: "overview_occupancy_filter",
    METRICS_SECTION_CARD: "metrics_section_card",
    METRICS_PREMIUM_ROW: "metrics_premium_row",
    EXPORT_SECTION_CHIP: "export_section_chip",
} as const);

export const ANALYZE_UPSELL_ACTIONS = Object.freeze({
    REQUEST_OFFER: "request_offer",
    LEARN_MORE: "learn_more",
    HARDWARE_LEARN_MORE: "hardware_learn_more",
} as const);
